module.exports = __webpack_public_path__ + "static/media/Razz_Img.31b5cfe9.png";